import { keepPercentOrLine } from '@/utils/utils';
import { Empty } from '@maxtropy/components';
import { apiV2AlarmRecordAnalysisAlarmTypeDistributionPost } from '@maxtropy/device-customer-apis-v2';
import { useRequest } from 'ahooks';
import { Spin } from 'antd';
import classNames from 'classnames';
import React, { useContext, useMemo } from 'react';
import { AlarmRecordsAnalysisContext } from '../..';
import { ColorMap, DateType } from '../../const';
import { getDefaultTime } from '../../utils';
import CardBox from '../CardBox';
import styles from './index.module.scss';

const AlarmTypeDistribution = () => {
  const {
    timeResolution,
    value,
    selectedSceneId,
    activeKey,
    setAlarmModalOpen,
    setSearchParams,
    searchParams,
    sceneTabList,
  } = useContext(AlarmRecordsAnalysisContext);

  // 统计等级统计
  const { data: alarmTypeDistribution, loading } = useRequest(
    async () => {
      return await apiV2AlarmRecordAnalysisAlarmTypeDistributionPost({
        sceneId: selectedSceneId,
        state: activeKey === 'all' ? undefined : activeKey,
        timeResolution: timeResolution === DateType.CUSTOM ? 'D' : timeResolution,
        startTime: getDefaultTime(timeResolution!, value?.[0]).startTime,
        endTime: getDefaultTime(timeResolution!, value?.[1]).endTime,
      });
    },
    {
      ready: !!timeResolution && !!value && !!activeKey,
      refreshDeps: [timeResolution, selectedSceneId, value, activeKey],
    }
  );

  const isEmpty = useMemo(() => {
    return !alarmTypeDistribution || alarmTypeDistribution?.list?.length === 0;
  }, [alarmTypeDistribution]);

  return (
    <CardBox title="报警类型分布">
      <div className={styles.content_wrapper} style={{ height: isEmpty ? '100%' : 374 }}>
        <Spin spinning={loading}>
          {isEmpty ? (
            <Empty />
          ) : (
            <>
              <div className={styles.top_ratio_bar}>
                {alarmTypeDistribution?.list?.map((item, index) => (
                  <div
                    className={styles.top_ratio_bar_item}
                    onClick={() => {
                      setSearchParams?.({
                        ...searchParams,
                        startTime: getDefaultTime(timeResolution!, value?.[0]).startTime,
                        endTime: getDefaultTime(timeResolution!, value?.[1]).endTime,
                        ruleLabelIds: item.labelId ? [item.labelId] : undefined,
                      });
                      setAlarmModalOpen?.(true);
                    }}
                    style={{
                      width: `${(item.proportion ?? 0) * 100}%`,
                      background: ColorMap[index],
                    }}
                    key={item.labelId}
                  />
                ))}
              </div>
              <div className={styles.ratio_table}>
                <div className={styles.header}>
                  <div className={styles.type}>类型</div>
                  <div className={styles.count}>数量</div>
                  <div className={styles.percent}>占比</div>
                </div>

                {alarmTypeDistribution?.list?.map((item, index) => (
                  <div
                    className={styles.row}
                    key={item.labelId}
                    onClick={() => {
                      setSearchParams?.({
                        ...searchParams,
                        startTime: getDefaultTime(timeResolution!, value?.[0]).startTime,
                        endTime: getDefaultTime(timeResolution!, value?.[1]).endTime,
                        ruleLabelIds: item.labelId ? [item.labelId] : undefined,
                        deviceLabelIds: selectedSceneId ? [selectedSceneId] : (sceneTabList ?? []).map(i => i.id!),
                      });
                      setAlarmModalOpen?.(true);
                    }}
                  >
                    <div className={styles.type}>
                      <span className={styles.dot} style={{ backgroundColor: ColorMap[index] }}></span>
                      <span className={styles.label}>{item.labelName}</span>
                    </div>
                    <div className={styles.count}>{item.count}</div>
                    <div className={styles.percent}>{keepPercentOrLine(item.proportion)}%</div>
                  </div>
                ))}
              </div>
            </>
          )}
        </Spin>
      </div>
    </CardBox>
  );
};

export default AlarmTypeDistribution;
